// extracted by mini-css-extract-plugin
module.exports = {"root":"LangButtons_root__2cxZe","box":"LangButtons_box__lYj8v","button":"LangButtons_button__dg23E","active":"LangButtons_active__2Qtdd"};